module.exports = __webpack_public_path__ + "static/media/LogoCientikBranca.68b6b3d0.svg";